// The chat column is the reference box for every floating layer that has to look like it
// still belongs to the chat: the channels card and the call window both sit over it rather
// than in it, and both have to line up with each other. MainLayout marks the box; everything
// that positions against it reads these constants rather than restating them, so moving the
// nav bar is one edit instead of a hunt through unrelated files.
export const CHAT_COLUMN_SELECTOR = '[data-chat-column]';

// Far enough down to clear the nav bar floating over the column's top.
export const CHAT_COLUMN_TOP_INSET = 72;
export const CHAT_COLUMN_LEFT_INSET = 16;

export const readChatColumnRect = () => document.querySelector(CHAT_COLUMN_SELECTOR)?.getBoundingClientRect() ?? null;

// Keeps a viewport-fixed box on screen. `topFloor` is a separate ceiling because a layer
// anchored under the nav bar must not slide behind it, where there would be nothing left to
// grab; the other three sides only need to clear the viewport edge.
export const clampToViewport = (position, size, { margin, topFloor = margin } = { margin: 12 }) => ({
  left: Math.min(Math.max(position.left, margin), Math.max(margin, window.innerWidth - size.width - margin)),
  top: Math.min(Math.max(position.top, topFloor), Math.max(topFloor, window.innerHeight - size.height - margin)),
});
